import { forIPad } from '@src/utility/styled';
import React from 'react';
import styled from 'styled-components';

import type { Music } from '../../../types.ts/story';
import type { Dispatch, SetStateAction } from 'react';

type Props = {
  music: Music[] | undefined;
  setSelectedGenre: Dispatch<SetStateAction<string>>;
};

const categories: Record<string, string> = {
  chill: 'Chill.png',
  dramatic: 'dramatic.png',
  exciting: 'exciting.png',
  groovy: 'groovy.png',
  happy: 'happy.png',
  hopeful: 'hopeful.png',
  inspirational: 'Inspirational.png',
  love: 'love.png',
  peaceful: 'peaceful.png',
  playful: 'playful.png',
  pop: 'pop.png',
  romantic: 'romantic.png',
  sad: 'sad.png',
  serious: 'serious.png',
  tense: 'tense.png',
  uplifting: 'uplifting.png',
  calm: 'peaceful.png',
  reflective: 'serious.png',
  sentimental: 'love.png',
};

const MusicTheme = (props: Props) => {
  return (
    <Theme>
      <>
        {props.music?.map(m => (
          <ThemeCards
            key={m.id}
            genre={m.genre.toLowerCase()}
            onClick={() => props.setSelectedGenre(m.genre)}
          >
            {m.genre}
          </ThemeCards>
        ))}
      </>
    </Theme>
  );
};

export default MusicTheme;

const Theme = styled.div`
  margin-top: var(--spacing-md);
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: var(--spacing-md);
  width: 100%;
  & > span {
    font-size: var(--text-sm);
  }
  margin-bottom: var(--spacing-md);

  ${forIPad(`
    grid-template-columns: repeat(2, minmax(0, 1fr));
  `)}
`;

const ThemeCards = styled.div<{ genre: string }>`
  display: flex;
  width: 100%;
  aspect-ratio: 1;
  justify-content: center;
  align-items: center;
  text-align: center;
  gap: var(--spacing-sm);
  border-radius: var(--radius-input);
  background:
    linear-gradient(0deg, rgba(0, 0, 0, 0.6) 0%, rgba(0, 0, 0, 0.1) 100%),
    url('/mood_thumbnails/${props => categories[props.genre]}');

  background-repeat: no-repeat;
  background-size: cover;
  border: 1px solid var(--border);
  font-weight: var(--font-weight-bold);
  cursor: pointer;
  text-transform: uppercase;
  font-size: 11px;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.8);
  &:hover {
    background: url('/mood_thumbnails/${props => categories[props.genre]}');
    background-repeat: no-repeat;
    background-size: cover;
  }
`;
